module.exports = __webpack_public_path__ + "static/img/coupon-modal-middle.2fea72b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/coupon/coupon-modal-middle.png
// module id = 5wtZ
// module chunks = 4